import { registerBreadcrumbs } from "shared/breadcrumbs/breadcrumbsRegistry";
import { KnittingProgramLibraryBreadcrumbsComponent } from "./knittingProgramLibraryBreadcrumbs.component";
import { ROUTES } from "routes";

export const registerKnittingProgramLibraryBreadcrumbs = () => {
  registerBreadcrumbs({
    component: KnittingProgramLibraryBreadcrumbsComponent,
    isActive: (pathname: string) =>
      pathname === ROUTES.ASSETS_KNITTING_PROGRAM_LIBRARY ||
      pathname.startsWith(`${ROUTES.ASSETS_KNITTING_PROGRAM_LIBRARY}/`),
  });
};
